import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
// import { Navbar, NavItem, Nav, NavDropdown} from "react-bootstrap";
// import logo from './logo.svg';
import './css/App.css';
import Routes from "./routes";
// import { LinkContainer } from "react-router-bootstrap";

import { css } from 'react-emotion';
import { CircleLoader } from 'react-spinners';

import moment from 'moment';
import {format_without_time} from './Utils';
import Config from './Config';
import {ROLES} from './Roles';
import { UserService } from './Services/UserService';

import Snackbar from '@material-ui/core/Snackbar';
import MySnackbarContent from './components/SnackBar';
import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AssignmentIcon from '@material-ui/icons/Assignment';
import StoreIcon from '@material-ui/icons/Store';
import WorkIcon from '@material-ui/icons/Work';
// import AssessmentIcon from '@material-ui/icons/Assessment';
// import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
// import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ScheduleIcon from '@material-ui/icons/Schedule';

import EventSeatIcon from '@material-ui/icons/EventSeat';
import HomeIcon from '@material-ui/icons/Home';
import PeopleIcon from '@material-ui/icons/People';
import Drawer from '@material-ui/core/Drawer';
import { withStyles } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import HelpIcon from '@material-ui/icons/Help';
import classNames from 'classnames';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

const drawerWidth = 300;
const styles = theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9 + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  sectionMobile: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionDesktop: {
    display: 'flex',
    fontSize: 16,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  accountCircle: {
    marginRight: theme.spacing.unit * 3
  }
});

class App extends Component {

  constructor(props) {
    super(props);
  
    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      user: null,
      loading : false,
      latitude: null,
      longitude: null,
      alertMessages: [],
      show: false,
      isAlertVisible: false,
      modules_enabled: {
        customer_app_options: false,
        inventory_management: false,
        b2c_module: true,
        b2b_module: true,
        promotions_module: true 
      },
      showStore: false,
      showPromotions: false,
      sb: {
          open : false,
          autohide: 6000,
      },
      openDialog: false,
      open: false,
      title: ""
    };

    this.updateUser = this.updateUser.bind(this);
    this.isLoading = this.isLoading.bind(this);
    this.updateLocation = this.updateLocation.bind(this);
    this.addAlertMessage = this.addAlertMessage.bind(this);
    this.alertPopover = this.alertPopover.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount(){
    let user = JSON.parse(localStorage.getItem('user'));
    this.setState({user: user});
    if(user == null) {
        this.props.history.push("/login");
    };
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  closeConfirmDialog = () => {
    this.setState({ openDialog: false });
  }

  handleSBClose = () => {
      this.setState(prevState => ({
          sb: {
              ...prevState.sb,
              open: false,
              message : '',
              varient: 'info'
          }
      }));
  }

  showSnackBar = (message, varient) => {
    this.setState(prevState => ({
        sb: {
            ...prevState.sb,
            open: true,
            message: message,
            varient: varient
        }
    }));
  }

  showConfirmDialog = (dialog_message, dialog_title, confirmAction) => {
    this.setState({
      dialog_message: dialog_message, 
      dialog_title: dialog_title,
      openDialog: true, 
      confirmAction: confirmAction
    });
  }

  setTitle = (message) => {
    this.setState({
      title: message
    });
  }

  alertPopover(){
    if(this.state.isAlertVisible){
      this.handleShow();
    }
  }

  handleClose() {
      this.setState({ show: false });
  }

  handleShow() {
      this.setState({ show: true });
  }

  async componentDidMount() {
    try {
      if (this.state.user !== null) {
        this.userHasAuthenticated(true);
      }
      if(this.state.user){
        let body = { mobile_no : this.state.user.mobile_no,
          code : this.state.user.code
        };
        UserService.authenticate(body)
        .then((data) => {
            if ( data.id && data.status === '1') {
                this.updateUser(data);
                localStorage.setItem('user', JSON.stringify(data));
                this.userHasAuthenticated(true);
                this.props.history.push(this.props.location.pathname);

                var dateToCheck = moment().set({hour:Config.defaultAlerts.import.hr,minute:Config.defaultAlerts.import.min,second:0,millisecond:0});
                if(moment().isAfter(dateToCheck)){
                  this.setState({alertMessages: [...this.state.alertMessages, <div key="import" style={{cursor: "pointer"}} onClick={()=> { this.handleClose(); this.props.history.push("/import") }}>Dont <strong>Forget</strong> to import schedules for {moment().format(format_without_time)}</div>]});
                }

                setTimeout(() =>{
                  this.setState({isAlertVisible: this.state.alertMessages.length > 0})
                }, 2000);
                setInterval(() =>{
                  this.setState({isAlertVisible: this.state.alertMessages.length > 0})
                }, 60000);
            } else {
                this.props.history.push("/login");
            }
        })
        .catch((error) => {
            this.props.history.push("/login");
        });
      }
    }
    catch(e) {
      if (e !== 'No current user') {
        alert(e);
      }
    }

    if (navigator.geolocation) {
        this.updateLocation();
    } else {
      // no can do
    }
  
    this.setState({ isAuthenticating: false });
  }

  updateLocation(position){
    navigator.geolocation.getCurrentPosition((position) =>{
      this.setState({latitude: position.coords.latitude, longitude: position.coords.longitude});
    });
  }

  addAlertMessage(alertMessages){
    this.setState(prevState => ({
      alertMessages: [...prevState.alertMessages, alertMessages]
    }));
  }

  isLoading(loading){
    this.setState({loading: loading});
  }
  
  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }

  handleLogout = event => {
    this.userHasAuthenticated(false);
    localStorage.removeItem('user');
    this.props.history.push("/login");
  }

  updateUser(user){
      this.setState({user: user});
  }

  render() {

    const { classes } = this.props;
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      user: this.state.user,
      updateUser: this.updateUser,
      isLoading: this.isLoading,
      loading: this.state.loading,
      latitude: this.state.latitude,
      longitude: this.state.longitude,
      updateLocation: this.updateLocation,
      addAlertMessage: this.addAlertMessage,
      modules_enabled: this.state.modules_enabled,
      showStore: this.state.showStore,
      showPromotions: this.state.showPromotions,
      showSnackBar: this.showSnackBar,  
      showConfirmDialog: this.showConfirmDialog,
      closeConfirmDialog: this.closeConfirmDialog,
      setTitle: this.setTitle
    };

    return (
      !this.state.isAuthenticating &&
      <div className="App container">
        <div className="root">
          <CssBaseline />
          <AppBar position="fixed"
          className={classNames(classes.appBar, {
            [classes.appBarShift]: this.state.open,
          })}
          >
            <Toolbar disableGutters={!this.state.open}>
            { this.state.isAuthenticated  &&
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.handleDrawerOpen}
                className={classNames(classes.menuButton, {
                  [classes.hide]: this.state.open,
                })}
              >
                <MenuIcon />
              </IconButton>
            }
            { !this.state.open && 
              <Typography variant="h6" color="inherit" className="grow">
                {this.state.title}
              </Typography>
            }
              { this.state.isAuthenticated &&
                <Button color="inherit" className={classes.sectionMobile} style={{position: "absolute", right: 130}}>{this.state.user.name}</Button>      
              }
              {this.state.isAuthenticated ? 
                <Button color="inherit" style={{position: "absolute", right: 20}}  onClick={this.handleLogout}>LogOut</Button>
              :
                <Button color="inherit" style={{position: "absolute", right: 20, color: "white"}}><Link to="/login" style={{color: "inherit", textDecoration: "none"}}>Login</Link></Button>
              }
            </Toolbar>
          </AppBar>
          { this.state.isAuthenticated  &&
            <Drawer
              variant="persistent"
              anchor="left"
              className={classNames(classes.drawer, {
                [classes.drawerOpen]: this.state.open,
                [classes.drawerClose]: !this.state.open,
              })}
              classes={{
                paper: classNames({
                  [classes.drawerOpen]: this.state.open,
                  [classes.drawerClose]: !this.state.open,
                }),
              }}
              open={this.state.open}
              onClick={this.handleDrawerClose}
            >
              <div className={classes.toolbar}>
                <IconButton onClick={this.handleDrawerClose}>
{/* <AccountCircleIcon className={classes.accountCircle}/> */}
                  { this.state.isAuthenticated &&
                    <section className={classes.sectionDesktop}>{this.state.user.name}</section>      
                  }
                  <ChevronLeftIcon />
                </IconButton>
              </div>
              <Divider />
              {
                  <Link to="/" style={{ textDecoration: 'none' }}>
                    <ListItem button key="Dashboard">
                      <ListItemIcon><HomeIcon /></ListItemIcon>
                      <ListItemText primary="Dashboard" />
                    </ListItem>
                  </Link>
              }
              { this.state.user.roles.includes(ROLES.ADMIN) &&
                  <Link to="/projects" style={{ textDecoration: 'none' }}>
                    <ListItem button key="Projects">
                      <ListItemIcon><AssignmentIcon /></ListItemIcon>
                      <ListItemText primary="Projects" />
                    </ListItem>
                  </Link>
              }
              { (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGER))  &&
                  <Link to="/items" style={{ textDecoration: 'none' }}>
                    <ListItem button key="Items">
                      <ListItemIcon><EventSeatIcon /></ListItemIcon>
                      <ListItemText primary="Items" />
                    </ListItem>
                  </Link>
              }
              {this.state.user.roles.includes(ROLES.ADMIN) &&
                <div>
                  <Divider />
                  <Typography variant="subtitle1" align="left" className="sub-menu">
                    Users
                  </Typography>
                    <Link to="/employees" style={{ textDecoration: 'none' }}>
                      <ListItem button key="Employees">
                        <ListItemIcon><PeopleIcon /></ListItemIcon>
                        <ListItemText primary="Employees" />
                      </ListItem>
                    </Link>
                    <Link to="/contractors" style={{ textDecoration: 'none' }}>
                      <ListItem button key="Contractors">
                        <ListItemIcon><PeopleIcon /></ListItemIcon>
                        <ListItemText primary="Contractors" />
                      </ListItem>
                    </Link>
                </div>
              }
              {this.state.user.roles.includes(ROLES.ADMIN) &&
                <div>
                <Divider />
                <Typography variant="subtitle1" align="left" className="sub-menu">
                  Reports
                </Typography>
                  { (this.state.user.roles.includes(ROLES.ADMIN)) &&
                      <Link to="/report/project" style={{ textDecoration: 'none' }}>
                        <ListItem button key="Project progress">
                          <ListItemIcon><ScheduleIcon /></ListItemIcon>
                          <ListItemText primary="Project progress" />
                        </ListItem>
                      </Link>
                  }
                  {/* <MenuItem divider /> */}
                  {/* {  this.state.user.roles.includes(ROLES.ADMIN) &&
                      <Link to="/report/summary" style={{ textDecoration: 'none' }}>
                        <ListItem button key="Summary">
                          <ListItemIcon><AssessmentIcon /></ListItemIcon>
                          <ListItemText primary="Summary" />
                        </ListItem>
                      </Link>
                  } */}
                </div>
              }
              { (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGER)) &&
                <div>
                  <Divider />
                  <Typography variant="subtitle1" align="left" className="sub-menu">
                    Transactions
                  </Typography>
                    <Link to="/transaction/store" style={{ textDecoration: 'none' }}>
                      <ListItem button key="Store Transactions">
                        <ListItemIcon><StoreIcon /></ListItemIcon>
                        <ListItemText primary="Store Transactions" />
                      </ListItem>
                    </Link>
                    <Link to="/transaction/jobstatus" style={{ textDecoration: 'none' }}>
                      <ListItem button key="Job Status">
                        <ListItemIcon><WorkIcon /></ListItemIcon>
                        <ListItemText primary="Job Status" />
                      </ListItem>
                    </Link>
                </div>
              }
              {  (this.state.user.roles.includes(ROLES.ADMIN)) &&
                <div>
                  <Divider />
                  <Typography variant="subtitle1" align="left" className="sub-menu">
                    Tools
                  </Typography>
                      {  (this.state.user.roles.includes(ROLES.ADMIN)) &&
                          <Link to="/tools/jobactions" style={{ textDecoration: 'none' }}>
                            <ListItem button key="Manage Job Actions">
                              {/* <ListItemIcon><AssignmentIndIcon /></ListItemIcon> */}
                              <ListItemText primary="Manage Job Actions" />
                            </ListItem>
                          </Link>
                      }
                      {/* {  (this.state.user.roles.includes(ROLES.ADMIN)) &&
                          <Link to="/tools/settings" style={{ textDecoration: 'none' }}>
                            <ListItem button key="Settings">
                              <ListItemIcon><SettingsIcon /></ListItemIcon>
                              <ListItemText primary="Settings" />
                            </ListItem>
                          </Link>
                      } */}
                </div>
              }
              <Divider />
              <Link to="/help" style={{ textDecoration: 'none' }}>
                <ListItem button key="Help">
                  <ListItemIcon><HelpIcon /></ListItemIcon>
                  <ListItemText primary="Help" />
                </ListItem>
              </Link>
            </Drawer>
          }
        </div>
        <Routes childProps={childProps} style={{width: "50%"}}/>
        <div className='sweet-loading'>
          <CircleLoader
            className={override}
            sizeUnit={"px"}
            size={50}
            color={'#123abc'}
            loading={this.state.loading}
          />
        </div>
        <Snackbar
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={this.state.sb.open}
            autoHideDuration={this.state.sb.autohide}
            onClose={this.handleSBClose}>
                <MySnackbarContent
                    onClose={this.handleSBClose}
                    variant={this.state.sb.varient}
                    message={this.state.sb.message}
                />
        </Snackbar>
        <DialogMUI
            disableEnforceFocus
            open={this.state.openDialog}
            onClose={this.closeConfirmDialog}
            fullWidth={true}
            maxWidth='sm'
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
                {this.state.dialog_title ? <DialogTitle id="alert-dialog-title">{this.state.dialog_title}</DialogTitle> : ''}
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {this.state.dialog_message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                      <Button onClick={this.closeConfirmDialog} color="primary">
                        {this.state.confirmAction ? "Cancel" : "Ok"}
                      </Button>
                      {
                        this.state.confirmAction &&
                        <Button onClick={this.state.confirmAction} color="primary" autoFocus>
                            Confirm
                        </Button>
                      }
                  }
                </DialogActions>
        </DialogMUI>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(App));
